var map = {
	"./mobile/article.vue": [
		"5744",
		"chunk-2d0c8d98"
	],
	"./pc/article.vue": [
		"1186",
		"chunk-3e1b9214",
		"chunk-1deb5d8f"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "f2f9";
module.exports = webpackAsyncContext;